
  <!--
 * 横版
 * @LastEditTime: Fri Apr 04 2025 19:11:26 GMT+0800 (中国标准时间)
 -->
  <template>
  <div id="u_r_0J3316" :class="[curLang]" class="u_r_0J3316 route-index"  ><u_c_P7GW32></u_c_P7GW32><u_c_Z2C155></u_c_Z2C155><u_c_KPGV409></u_c_KPGV409><u_c_LVEH374></u_c_LVEH374><u_c_W10E19></u_c_W10E19><u_c_WSHP87></u_c_WSHP87><div id="u_c_WB8164"  :class="[`normal shareContainer`,`u_c_WB8164`]" ></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_P7GW32 from "@/components/u_c_P7GW32.vue";import u_c_Z2C155 from "@/components/u_c_Z2C155.vue";import u_c_KPGV409 from "@/components/u_c_KPGV409.vue";import u_c_LVEH374 from "@/components/u_c_LVEH374.vue";import u_c_W10E19 from "@/components/u_c_W10E19.vue";import u_c_WSHP87 from "@/components/u_c_WSHP87.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"en-US":{},"th-TH":{},"ru-RU":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['en-US']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});

    const curRouterCompMap = {"home":{"value":"home","name":"首页","uuid":"u_c_LVEH374","id":"element_7NTW17"},"task":{"value":"task","name":"任务中心","uuid":"u_c_W10E19","id":"element_NIJ124"},"sign":{"value":"sign","name":"签到领奖","uuid":"u_c_WSHP87","id":"element_UBXT19"}};
    provide("curRouterCompMap", curRouterCompMap);

    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    const init = inject('init', () => {});
const api = inject('api');
if (window.innerWidth < window.innerHeight && router.hasRoute('m')) {
  let routerCount = router.router.getRoutes().length;
  if (routerCount < 3) {
    init();
  } else {
    router.gotoRouter('/m');
  }
} else {
  init();
}

// 初始化分享
const initShare = () => {
  const shareChannel =
    pageData.shareChannel?.filter((item) => item?.channel) || [];
  if (shareChannel.length === 0) {
    return;
  }

  const shareUrl = new URL(window.location.href);
  shareUrl.search = `?language=${curLang}`;

  // 分享信息
  const shareInfo = {
    appKey: pageData.shareAppKey,
    appId: pageData.shareAppId,
    aid: pageData.pageId,
    gameId: pageData.gameId,
    title: pageData.shareTitle,
    content: pageData.shareContent,
    url: shareUrl,
    shareBtnText: 'konw more',
    shareImageArr: pageData.shareImage ? [pageData.shareImage] : [],
    shareSdkLoadedCallback: () => {
      console.log('shareSdkLoadedCallback');
    },
    shareSuccessCallback: async function() {
      console.log('shareSuccessCallback');
      await api.shareCallback(1, this.pointName, '');
      window.activityDataLayer.push({
        eventName: 'share',
        eventType: this.pointName,
      });
    },
    shareFailCallback: function(errorMsg) {
      console.log('shareFailCallback');
      api.shareCallback(0, this.pointName, errorMsg);
      window.activityDataLayer.push({
        eventName: 'share',
        eventType: this.pointName,
      });
    },
  };
  // 创建分享工厂实例
  pageData.shareFactoryInst = new window.ShareFactory(shareInfo);
  // 创建分享实例
  shareChannel.forEach((item) => {
    pageData.shareFactoryInst.createShareInst({
      type: item.channel,
    });
  });

  pageData.shareFactoryInst.mountPopup({
    ele: '.shareContainer',
    themeMode: 'light',
    iconSize: 64,
    iconGap: 24,
    iconRowNum: 3,
    showText: true,
    autoHidePopup: true,
    titleSlot: '',
    btnSlot: '',
    useCopyBtn: true,
    useSaveBtn: false,
    textColor: '#333333',
    popupBackground: `url(${pageData.popupBg})`,
    btnBackground: `linear-gradient(to right, ${pageData.linearColorStart}, ${pageData.linearColorEnd})`,
  });
};

onMounted(() => {
  initShare();
});
    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>

.u_r_0J3316.en-US ::v-deep(.normal .txt-size){
font-size:1.46vw;

}

.u_r_0J3316.en-US ::v-deep(.normal .popup-title){
font-size:2.40vw;
text-align:center;

}

.u_r_0J3316.en-US ::v-deep(.normal .highlight-txt){
font-size:1.67vw;
font-weight:bold;

}

.u_r_0J3316.en-US ::v-deep(.normal .btn-text){
font-size:1.67vw;

}

.u_r_0J3316.en-US ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
width:22.81vw;
height:7.81vw;

}
/* 手机安全区域 */
.route-index {
/*   top: env(safe-area-inset-top);
  right: env(safe-area-inset-right);
  bottom: env(safe-area-inset-bottom); */
/*   margin-left: env(safe-area-inset-left); */
}

.en-US ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
background-repeat:no-repeat;
background-size:cover;

}

.en-US ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.en-US ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733219339177-45.png);

}

.en-US ::v-deep(.normal .btn-text){
font-size:1.67vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}

.en-US ::v-deep(.normal .flex-center){
display:flex;
justify-content:center;
align-items:center;

}

.en-US ::v-deep(.normal .highlight-txt){
color:#ffffff;

}

.en-US ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.en-US ::v-deep(.normal .popup-content-small){
width:35.94vw;
height:fit-content;
position:relative;
box-sizing:border-box;
padding:2.08vw;
border-radius:1.35vw;
min-height:31.25vw;
border:solid 0.31vw #2e8246;

}

.en-US ::v-deep(.normal .popup-close){
width:2.19vw;
height:2.19vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1743401445730-72.png);

}

.en-US ::v-deep(.normal .popup-content-big){
width:35.94vw;
height:fit-content;
position:relative;
box-sizing:border-box;
padding:2.08vw;
border-radius:1.35vw;
border:solid 0.31vw #2e8246;

}

.en-US ::v-deep(.normal .sure){
display:flex;
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;
border-radius:1.20vw;
width:fit-content;
box-sizing:border-box;
padding:0.52vw 1.04vw;
min-width:15.83vw;
min-height:3.65vw;

}

.en-US ::v-deep(.normal .popup-title-color){
color:#ffffff;

}

.en-US ::v-deep(.normal .txt-color){
color:#ffffff;

}

.en-US ::v-deep(.normal .tips-color){
color:#ffffff;

}

.en-US ::v-deep(.normal .border-color){
border:1px solid;
border-color:#f4d2aa;
border-radius:0.73vw;

}

.en-US ::v-deep(.normal .full-popup-close){
width:3.33vw;
height:3.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808492-35.png);

}

.en-US ::v-deep(.normal .sub-title-bg){
background:#000000B3;
border-radius:0.73vw;
width:fit-content;

}

.en-US ::v-deep(.normal .txt){
color:#ffffff;

}

.en-US ::v-deep(.normal .mult-lottery-popup-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808610-76.png);

}

.en-US ::v-deep(.normal .mult-lottery-popup-reward-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186839608-37.png);

}

.en-US ::v-deep(.normal .mult-lottery-popup-title){
font-size:2.08vw;
color:#ffdd57;

}
.btn-light:hover {
  filter: brightness(1.2);
  cursor: pointer;
}

html,
body {
  height: auto !important;
  width: 100%;
}

[dir=rtl] .rtl-trans {
  transform: scaleX(-1);
}

.swiper-button-disabled {
  display: none;
}

.zoom-in {
  animation: zoomIn;
  animation-duration: 0.8s;
}

.swing {
  animation: swing ease-in-out 0.8s infinite;
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.u_r_0J3316.th-TH ::v-deep(.normal .txt-size){
font-size:1.46vw;

}

.u_r_0J3316.th-TH ::v-deep(.normal .popup-title){
font-size:2.40vw;
text-align:center;

}

.u_r_0J3316.th-TH ::v-deep(.normal .highlight-txt){
font-size:1.67vw;
font-weight:bold;

}

.u_r_0J3316.th-TH ::v-deep(.normal .btn-text){
font-size:1.67vw;

}

.u_r_0J3316.th-TH ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
width:22.81vw;
height:7.81vw;

}
/* 手机安全区域 */
.route-index {
/*   top: env(safe-area-inset-top);
  right: env(safe-area-inset-right);
  bottom: env(safe-area-inset-bottom); */
/*   margin-left: env(safe-area-inset-left); */
}

.th-TH ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
background-repeat:no-repeat;
background-size:cover;

}

.th-TH ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.th-TH ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733219339177-45.png);

}

.th-TH ::v-deep(.normal .btn-text){
font-size:1.67vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}

.th-TH ::v-deep(.normal .flex-center){
display:flex;
justify-content:center;
align-items:center;

}

.th-TH ::v-deep(.normal .highlight-txt){
color:#ffffff;

}

.th-TH ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.th-TH ::v-deep(.normal .popup-content-small){
width:35.94vw;
height:fit-content;
position:relative;
box-sizing:border-box;
padding:2.08vw;
border-radius:1.35vw;
min-height:31.25vw;
border:solid 0.31vw #2e8246;

}

.th-TH ::v-deep(.normal .popup-close){
width:2.19vw;
height:2.19vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1743401445730-72.png);

}

.th-TH ::v-deep(.normal .popup-content-big){
width:35.94vw;
height:fit-content;
position:relative;
box-sizing:border-box;
padding:2.08vw;
border-radius:1.35vw;
border:solid 0.31vw #2e8246;

}

.th-TH ::v-deep(.normal .sure){
display:flex;
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;
border-radius:1.20vw;
width:fit-content;
box-sizing:border-box;
padding:0.52vw 1.04vw;
min-width:15.83vw;
min-height:3.65vw;

}

.th-TH ::v-deep(.normal .popup-title-color){
color:#ffffff;

}

.th-TH ::v-deep(.normal .txt-color){
color:#ffffff;

}

.th-TH ::v-deep(.normal .tips-color){
color:#ffffff;

}

.th-TH ::v-deep(.normal .border-color){
border:1px solid;
border-color:#f4d2aa;
border-radius:0.73vw;

}

.th-TH ::v-deep(.normal .full-popup-close){
width:3.33vw;
height:3.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808492-35.png);

}

.th-TH ::v-deep(.normal .sub-title-bg){
background:#000000B3;
border-radius:0.73vw;
width:fit-content;

}

.th-TH ::v-deep(.normal .txt){
color:#ffffff;

}

.th-TH ::v-deep(.normal .mult-lottery-popup-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808610-76.png);

}

.th-TH ::v-deep(.normal .mult-lottery-popup-reward-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186839608-37.png);

}

.th-TH ::v-deep(.normal .mult-lottery-popup-title){
font-size:2.08vw;
color:#ffdd57;

}
.btn-light:hover {
  filter: brightness(1.2);
  cursor: pointer;
}

html,
body {
  height: auto !important;
  width: 100%;
}

[dir=rtl] .rtl-trans {
  transform: scaleX(-1);
}

.swiper-button-disabled {
  display: none;
}

.zoom-in {
  animation: zoomIn;
  animation-duration: 0.8s;
}

.swing {
  animation: swing ease-in-out 0.8s infinite;
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.u_r_0J3316.ru-RU ::v-deep(.normal .txt-size){
font-size:1.46vw;

}

.u_r_0J3316.ru-RU ::v-deep(.normal .popup-title){
font-size:2.40vw;
text-align:center;

}

.u_r_0J3316.ru-RU ::v-deep(.normal .highlight-txt){
font-size:1.67vw;
font-weight:bold;

}

.u_r_0J3316.ru-RU ::v-deep(.normal .btn-text){
font-size:1.67vw;

}

.u_r_0J3316.ru-RU ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
width:22.81vw;
height:7.81vw;

}
/* 手机安全区域 */
.route-index {
/*   top: env(safe-area-inset-top);
  right: env(safe-area-inset-right);
  bottom: env(safe-area-inset-bottom); */
/*   margin-left: env(safe-area-inset-left); */
}

.ru-RU ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
background-repeat:no-repeat;
background-size:cover;

}

.ru-RU ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.ru-RU ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733219339177-45.png);

}

.ru-RU ::v-deep(.normal .btn-text){
font-size:1.67vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}

.ru-RU ::v-deep(.normal .flex-center){
display:flex;
justify-content:center;
align-items:center;

}

.ru-RU ::v-deep(.normal .highlight-txt){
color:#ffffff;

}

.ru-RU ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.ru-RU ::v-deep(.normal .popup-content-small){
width:35.94vw;
height:fit-content;
position:relative;
box-sizing:border-box;
padding:2.08vw;
border-radius:1.35vw;
min-height:31.25vw;
border:solid 0.31vw #2e8246;

}

.ru-RU ::v-deep(.normal .popup-close){
width:2.19vw;
height:2.19vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1743401445730-72.png);

}

.ru-RU ::v-deep(.normal .popup-content-big){
width:35.94vw;
height:fit-content;
position:relative;
box-sizing:border-box;
padding:2.08vw;
border-radius:1.35vw;
border:solid 0.31vw #2e8246;

}

.ru-RU ::v-deep(.normal .sure){
display:flex;
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;
border-radius:1.20vw;
width:fit-content;
box-sizing:border-box;
padding:0.52vw 1.04vw;
min-width:15.83vw;
min-height:3.65vw;

}

.ru-RU ::v-deep(.normal .popup-title-color){
color:#ffffff;

}

.ru-RU ::v-deep(.normal .txt-color){
color:#ffffff;

}

.ru-RU ::v-deep(.normal .tips-color){
color:#ffffff;

}

.ru-RU ::v-deep(.normal .border-color){
border:1px solid;
border-color:#f4d2aa;
border-radius:0.73vw;

}

.ru-RU ::v-deep(.normal .full-popup-close){
width:3.33vw;
height:3.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808492-35.png);

}

.ru-RU ::v-deep(.normal .sub-title-bg){
background:#000000B3;
border-radius:0.73vw;
width:fit-content;

}

.ru-RU ::v-deep(.normal .txt){
color:#ffffff;

}

.ru-RU ::v-deep(.normal .mult-lottery-popup-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808610-76.png);

}

.ru-RU ::v-deep(.normal .mult-lottery-popup-reward-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186839608-37.png);

}

.ru-RU ::v-deep(.normal .mult-lottery-popup-title){
font-size:2.08vw;
color:#ffdd57;

}
.btn-light:hover {
  filter: brightness(1.2);
  cursor: pointer;
}

html,
body {
  height: auto !important;
  width: 100%;
}

[dir=rtl] .rtl-trans {
  transform: scaleX(-1);
}

.swiper-button-disabled {
  display: none;
}

.zoom-in {
  animation: zoomIn;
  animation-duration: 0.8s;
}

.swing {
  animation: swing ease-in-out 0.8s infinite;
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.u_r_0J3316.default ::v-deep(.normal .txt-size){
font-size:1.46vw;

}

.u_r_0J3316.default ::v-deep(.normal .popup-title){
font-size:2.40vw;
text-align:center;

}

.u_r_0J3316.default ::v-deep(.normal .highlight-txt){
font-size:1.67vw;
font-weight:bold;

}

.u_r_0J3316.default ::v-deep(.normal .btn-text){
font-size:1.67vw;

}

.u_r_0J3316.default ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
width:22.81vw;
height:7.81vw;

}
/* 手机安全区域 */
.route-index {
/*   top: env(safe-area-inset-top);
  right: env(safe-area-inset-right);
  bottom: env(safe-area-inset-bottom); */
/*   margin-left: env(safe-area-inset-left); */
}

.default ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
background-repeat:no-repeat;
background-size:cover;

}

.default ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.default ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733219339177-45.png);

}

.default ::v-deep(.normal .btn-text){
font-size:1.67vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}

.default ::v-deep(.normal .flex-center){
display:flex;
justify-content:center;
align-items:center;

}

.default ::v-deep(.normal .highlight-txt){
color:#ffffff;

}

.default ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.default ::v-deep(.normal .popup-content-small){
width:35.94vw;
height:fit-content;
position:relative;
box-sizing:border-box;
padding:2.08vw;
border-radius:1.35vw;
min-height:31.25vw;
border:solid 0.31vw #2e8246;

}

.default ::v-deep(.normal .popup-close){
width:2.19vw;
height:2.19vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1743401445730-72.png);

}

.default ::v-deep(.normal .popup-content-big){
width:35.94vw;
height:fit-content;
position:relative;
box-sizing:border-box;
padding:2.08vw;
border-radius:1.35vw;
border:solid 0.31vw #2e8246;

}

.default ::v-deep(.normal .sure){
display:flex;
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;
border-radius:1.20vw;
width:fit-content;
box-sizing:border-box;
padding:0.52vw 1.04vw;
min-width:15.83vw;
min-height:3.65vw;

}

.default ::v-deep(.normal .popup-title-color){
color:#ffffff;

}

.default ::v-deep(.normal .txt-color){
color:#ffffff;

}

.default ::v-deep(.normal .tips-color){
color:#ffffff;

}

.default ::v-deep(.normal .border-color){
border:1px solid;
border-color:#f4d2aa;
border-radius:0.73vw;

}

.default ::v-deep(.normal .full-popup-close){
width:3.33vw;
height:3.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808492-35.png);

}

.default ::v-deep(.normal .sub-title-bg){
background:#000000B3;
border-radius:0.73vw;
width:fit-content;

}

.default ::v-deep(.normal .txt){
color:#ffffff;

}

.default ::v-deep(.normal .mult-lottery-popup-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186808610-76.png);

}

.default ::v-deep(.normal .mult-lottery-popup-reward-bg){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735186839608-37.png);

}

.default ::v-deep(.normal .mult-lottery-popup-title){
font-size:2.08vw;
color:#ffdd57;

}
.btn-light:hover {
  filter: brightness(1.2);
  cursor: pointer;
}

html,
body {
  height: auto !important;
  width: 100%;
}

[dir=rtl] .rtl-trans {
  transform: scaleX(-1);
}

.swiper-button-disabled {
  display: none;
}

.zoom-in {
  animation: zoomIn;
  animation-duration: 0.8s;
}

.swing {
  animation: swing ease-in-out 0.8s infinite;
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.u_c_WB8164.normal{
position:relative;

}

</style>
